import React, { FC } from 'react'
import { Edit, EditProps } from 'react-admin'
import RouteBreadcrumbs from '../../components/RouteBreadcrumbs'
import ProfileItemForm from './ProfileItemForm'

const Title = ({ record }: any) => {
  return <>{record.vendor.code}'s profile items</>
}

const transform = (data: any) => ({
  id: data.id,
  description: data.description || null,
  vendor_fk: data.vendor_fk,
  default_gross_weight: data.default_gross_weight,
})

const ProfileItemEdit: FC<EditProps> = (props) => {
  return (
    <>
      <RouteBreadcrumbs {...props} />
      <Edit {...props} title={<Title />} transform={transform}>
        <ProfileItemForm />
      </Edit>
    </>
  )
}

export default ProfileItemEdit
